import gql from "graphql-tag";

export default gql`
  mutation DestroyPost($objectId: ID!) {
    destroyPost(objectId: $objectId)
  }
`;
